import AppRoute from './routes';
import ColorModeProvider from './theme/ColorModeProvider';
import { TimerProvider } from './contexts/Timer/TimerProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useSessionRefresh from './hooks/useSessionRefresh';

function App() {
  // Keeps a signed-in session alive across app opens — see the hook for why.
  useSessionRefresh();

  return (
    <ColorModeProvider>
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        // Moved off the top-right so toasts stop covering the page actions
        // that sit in that corner. At the bottom they have to clear the
        // mobile tab bar and the iOS home indicator instead.
        style={{ bottom: 'calc(72px + env(safe-area-inset-bottom))' }}
      />
      <TimerProvider>
        <AppRoute />
      </TimerProvider>
    </ColorModeProvider>
  );
}

export default App;
